import { render, staticRenderFns } from "./AdiAnagraficaComponent.vue?vue&type=template&id=c32dfa2a"
import script from "./AdiAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./AdiAnagraficaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports